import { CursorData } from "../models/TrendingModels";

const getValuesAtCursor = (chart: any, timeAtCursor: any): any[] => {
	const valuesAtCursor: any[] = [];
	chart.data.datasets.forEach((dataset: any) => {
		let previousDataPoint = null;
		for (let i = 0; i < dataset.data.length; i++) {
			if (dataset.data[i].x.getTime() <= timeAtCursor) {
				previousDataPoint = dataset.data[i];
			} else {
				break;
			}
		}
		if (previousDataPoint) {
			valuesAtCursor.push(previousDataPoint.y);
		}
	});
	return valuesAtCursor;
};

export const updateCursorData = (
	chart: any,
	setCursorData: (cursorData: CursorData) => void,
) => {
	const xScale = chart.scales.x;

	// Coordenadas para la primera y segunda línea
	const timeAtCursor1 = xScale.getValueForPixel(chart.mouseX);
	const timeAtCursor2 = xScale.getValueForPixel(chart.secondLineX);

	// Los valores en el punto del cursor pueden ser diferentes
	const valuesAtCursor1 = getValuesAtCursor(chart, timeAtCursor1);
	const valuesAtCursor2 = getValuesAtCursor(chart, timeAtCursor2);

	setCursorData({
		x1: timeAtCursor1,
		x2: timeAtCursor2,
		values: [...valuesAtCursor1, ...valuesAtCursor2],
	});
};
